var map = {
	"./Laluna-Logo.png": 302,
	"./abdoment.jpg": 6353,
	"./backneckshoulder.png": 6447,
	"./basicmanicure.jpg": 1919,
	"./basicpedicure.png": 570,
	"./child.png": 4889,
	"./coffeescrub.jpg": 7706,
	"./combo.jpg": 5113,
	"./cucumber.png": 3223,
	"./darksea.jpg": 6670,
	"./eyerelaxing.jpg": 9566,
	"./facial.png": 6355,
	"./footreflexology.png": 5821,
	"./greentea.jpg": 6830,
	"./greentea.png": 7898,
	"./hairwashing.png": 1092,
	"./healingstone.png": 1970,
	"./heelscrub.jpg": 1680,
	"./honey.png": 2182,
	"./hotherbal.png": 4428,
	"./indian.jpg": 7274,
	"./intro.jpg": 8173,
	"./lalunamanicure.jpeg": 5607,
	"./lalunapedicure.jpg": 4707,
	"./legtherapy.jpg": 6752,
	"./manicurekid.png": 9145,
	"./milkscrub.jpg": 4109,
	"./oatmeal.jpg": 3078,
	"./pedicurechildren.png": 3717,
	"./pregnancy.png": 3730,
	"./ricebran.png": 249,
	"./saltscrub.jpg": 950,
	"./sauna.jpeg": 3486,
	"./seasamescrub.jpg": 5863,
	"./shellacremoval.png": 7521,
	"./shiatsu.png": 1702,
	"./signature.png": 5621,
	"./spa1.png": 3388,
	"./swedish.png": 8532,
	"./thai.png": 9037,
	"./vitamin.jpg": 6633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;